package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.EditServiceSectionData
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberFind

@Composable
fun AreaSectionItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
) {
    Spacer(modifier = Modifier.height(4.spacing))
    val area = rememberFind(
        state.getAllArea.data.orEmpty(),
        state.service.value.areaId,
    ) { it.id }

    EsInputDropdownMenu(
        items = state.getAllArea.data
            .orEmpty()
            .sortedBy { it.name },
        selectedItem = area,
        text = { it.name ?: "" },
        onItemSelected = {
            onEvent(
                AddEditServiceEvent.UpdateServiceFields(
                    state.service.value.copy(
                        areaId = it.id,
                    ),
                ),
            )
        },
        label = "Area",
        placeholder = "Select Area",
        enabled = enabled,
        modifier = Modifier.offset(
            x = 0.dp,
            y = (-20).dp,
        ),
    )
}

